<template>
  <Widget :title="$t('components.ReviewStats.Title')" :loading="loading" :report-mode="reportMode">
    <v-row align="center" justify="space-between" style="width: 100%">
      <v-col cols="12" sm="4">
                <span class="d-inline-block mx-4 text-caption ddwhite--text"
                      v-for="(item, index) in Object.values(legend)" :key="index">
                    <span class="circle" :style="{ backgroundColor: item.color }"></span>
                    <span class="label">{{ item.title }}</span>
                </span>
      </v-col>

      <v-col cols="12" sm="4" class="text-right" v-if="!isReport">
                <span class="d-block input-label mr-6 ddgrey--text text-caption">
                    {{ $t("components.ChatsStats.FilterText") }}
                </span>
        <v-select
            solo
            dense
            class="d-inline-block groupby"
            v-model="groupBy"
            item-text="hint"
            item-value="value"
            :items="[
                        { value: 'all', hint: $t('components.ChatsStats.AllGroupsLabel') },
                        { value: 'positive', hint: $t('components.ReviewStats.PositiveReviewsLabel') },
                        { value: 'rest', hint: $t('components.ReviewStats.RestOfReviewsLabel') } ]"
            :label="$t('components.ChatsStats.FilterText')"
            @change="filterData(data)"/>
      </v-col>

      <v-col cols="12" sm="4" class="text-right" v-if="!isReport">
                <span class="d-block input-label mr-6 ddgrey--text text-caption">
                    {{ $t("components.ReviewStats.GroupText") }}
                </span>
        <v-select
            solo
            dense
            class="d-inline-block groupby"
            v-model="filterBy"
            item-text="hint"
            item-value="value"
            :items="[
                        { value: 'by_month', hint: $t('components.ReviewStats.MonthLabel') },
                        { value: 'by_month_accumulative', hint: $t('components.ReviewStats.MonthCumulativeLabel') },
                        { value: 'by_day_of_week', hint: $t('components.ReviewStats.DayLabel') }]"
            :label="$t('components.ReviewStats.GroupText')"
            @change="filterData(data)"/>
      </v-col>
    </v-row>
    <StackedBarChart :stats="stats" :styles="styles"/>
  </Widget>
</template>

<script>


import {DayLabels} from '@/mixins/TimeLabels';

import Widget from '@/components/dashboard/Widget';

import StackedBarChart from '@/components/dashboard/charts/StackedBarChart';

export default {
  name: 'ReviewsStats',
  data: () => ({
    stats: {},
    styles: {
      position: 'relative',
      width: '100%',
      padding: '24px 24px 0',
    },
    groupBy: 'all',
    filterBy: 'by_month',
    legend: [],
  }),
  props: {
    loading: {
      type: Boolean,
      default: true
    },
    reviewsData: {
      type: Object,
      required: true
    },
    reportMode: {
      type: String,
      default: null
    }
  },
  computed: {
    isReport() {
      return this.reportMode !== null
    },
    colors() {
      return this.$vuetify.theme.isDark ?
          this.$vuetify.theme.themes.dark : this.$vuetify.theme.themes.light;
    }
  },
  mounted() {
    this.inflateLegend();
    this.updateStats(this.reviewsData);
    console.log("STATS mounted");
  },
  watch: {
    reviewsData(newData) {
      this.updateStats(newData);
    },
    groupBy() {
      this.updateStats(this.reviewsData);
    },
    filterBy() {
      this.updateStats(this.reviewsData);
    }
  },
  methods: {
    inflateLegend() {
      const $t = this.$t.bind(this);
      this.legend = {
        reviews: {
          title: $t("components.ReviewStats.PositiveReviewsLabel"),
          color: this.colors.ddorange
        },
        positive_reviews: {
          title: $t("components.ReviewStats.RestOfReviewsLabel"),
          color: this.colors.ddlightblue
        }
      }
    },
    updateStats(data) {
      if (data) {
        const items = this.filterData(data);
        this.stats = this.formatItems(items);
      }
      switch (this.reportMode) {
        case 'daily':
          this.filterBy = 'by_hour';
          break;
        case 'weekly':
          this.filterBy = 'by_day';
          break;
        case 'monthly':
          this.filterBy = 'by_month';
          break;
      }
    },
    filterData(data) {
      const $t = this.$t.bind(this);
      const items = data[this.filterBy];
      if (items) {
        let formatedItems = {};
        let labels = [];

        switch (this.filterBy) {
          case 'by_month':
          case 'by_month_accumulative':
            labels = Object.keys(items);
            break;
          case 'by_day_of_week':
            labels = DayLabels.map(l => $t(`components.ChatsStats.${l}`));
            break;
            // case 'by_hour':
            //     labels = HourRangesLabels;
            //     break;
        }

        const keys = Object.keys(items);
        const {length} = keys;
        for (let i = 0; i < length; i++) {
          const key = keys[i];
          const label = labels[i];
          formatedItems[label] = items[key];
        }
        return formatedItems;
      }

      return {};
    },
    formatItems(items) {
      const $t = this.$t.bind(this);
      const labels = [...Object.keys(items)];
      const datasets = [];
      const positiveReviews = {
        barPercentage: 0.5,
        label: $t("components.ReviewStats.PositiveReviewsLabel"),
        backgroundColor: this.colors.ddorange,
        data: []
      }
      const restOfReviews = {
        barPercentage: 0.5,
        label: $t("components.ReviewStats.RestOfReviewsLabel"),
        backgroundColor: this.colors.ddlightblue,
        data: []
      }

      const {length} = labels;
      for (let i = 0; i < length; i++) {
        const item = items[labels[i]];
        console.log(item);
        positiveReviews.data.push(item.positive_reviews);
        restOfReviews.data.push(item.rest_of_reviews);
      }
      const { groupBy } = this;
      switch (groupBy) {
        case 'positive':
          datasets.push(positiveReviews);
          break;
        case 'rest':
          datasets.push(restOfReviews);
          break;
        case 'all':
          datasets.push(restOfReviews);
          datasets.push(positiveReviews);
          break;
      }

      return { labels, datasets };
    }
  },
  components: {Widget, StackedBarChart}
}
</script>

<style>
.circle {
  display: inline-block;
  vertical-align: top;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin: 4px 12px;
}

.label {
  font-size: 1.2em !important;
}

.input-label.input-label {
  font-size: 1.02em !important;
}

.groupby .v-text-field__details {
  display: none;
}
</style>